import _ from "lodash";
import React, { useRef, useState } from "react";
import classes from "./IconCell.scss";
import { useI18n } from "Hooks";
import { Button, CropModal, IconButton, Tooltip } from "@toddle-edu/ds-web";
import { PencilLineOutlined, UploadOutlined } from "@toddle-edu/ds-icons";
import classNames from "classnames";
import { uploadFileV2 } from "modules/Services";
import { generateRandomId, getAttachmentSendObj } from "Utils";
import { connect } from "react-redux";

import { getIconList } from "GenericTableEditor/IconPicker/IconPickerUtils";
import IconPicker from "GenericTableEditor/IconPicker";
import { tooltipStyle } from "./IconCellStyles";

const IconCell = props => {
  const { icon, onUpdateIcon, uploadFileV2, containerParentRef } = props;

  const [selectedImage, setSelectedImage] = useState({});
  const [showIconPicker, setShowIconPicker] = useState(false);
  const [showCropImageModal, setShowCropImageModal] = useState(false);

  const { t } = useI18n(["common"]);

  const containerRef = useRef(null);

  const figcaptionClasses = classNames(classes.figCaption, "text-body-1");

  const iconListForPreview = getIconList({ size: "xx-small" });
  const iconListForPicker = getIconList();

  const toggleIconPicker = () => {
    setShowIconPicker(!showIconPicker);
  };

  const toggleCropImageModal = () => {
    setShowCropImageModal(!showCropImageModal);
  };

  const onSelectImage = image => {
    setSelectedImage(image);
    toggleCropImageModal();
  };

  const dataURLtoBlob = dataUrl => {
    var arr = dataUrl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new Blob([u8arr], { type: mime });
  };

  const onAdd = async image => {
    toggleCropImageModal();

    const blob = dataURLtoBlob(image);
    const type = blob.type;
    const preview = URL.createObjectURL(dataURLtoBlob(image));
    const file = new File([blob], _.get(selectedImage, "name", ""), {
      type: type,
    });
    file.preview = preview;

    const sendObj = await getAttachmentSendObj(file, `${file.preview}`);

    const item = await uploadFileV2({
      file,
      attachment: sendObj,
      uploadId: generateRandomId(),
    });

    const imageObj = { ...sendObj, url: item };

    onUpdateIcon({ icon: imageObj });
  };

  return (
    <div ref={containerRef}>
      {_.isEmpty(icon) ? (
        <Button
          icon={<UploadOutlined />}
          variant="inline-progressive"
          onClick={toggleIconPicker}
        >
          {t("common:upload")}
        </Button>
      ) : (
        <div className={classes.iconCell}>
          <figure className={classes.figureContainer}>
            {icon.url ? (
              <img src={icon.url} alt={icon.name} className={classes.figure} />
            ) : (
              _.get(iconListForPreview, icon.metadata.iconName, {}).component
            )}

            <Tooltip
              tooltip={icon.name}
              placement="bottom"
              overlayInnerStyle={tooltipStyle}
              align={{ offset: [0, -8] }}
            >
              <figcaption className={figcaptionClasses}>{icon.name}</figcaption>
            </Tooltip>
          </figure>
          <IconButton
            variant="inline-progressive"
            size="small"
            icon={<PencilLineOutlined />}
            onClick={toggleIconPicker}
          />
        </div>
      )}

      {showCropImageModal ? (
        <CropModal
          ratio={"1:1"}
          onClose={toggleCropImageModal}
          onAdd={onAdd}
          image={_.get(selectedImage, "url", "")}
        />
      ) : null}

      {showIconPicker ? (
        <IconPicker
          selectedIconName={_.get(icon, "metadata.iconName")}
          iconList={_.values(iconListForPicker)}
          onUpdateIcon={onUpdateIcon}
          containerParentRef={containerParentRef}
          childrenRef={containerRef}
          onSelectImage={onSelectImage}
          toggleIconPicker={toggleIconPicker}
        />
      ) : null}
    </div>
  );
};

const mapActionCreators = {
  uploadFileV2,
};

export default connect(null, mapActionCreators)(IconCell);
